var app = angular.module('directives.mobileDropdown');
app.directive('mobileDropdown', [
    'configs',
    '$translate',
    '$location',
    '$state',
    '$interval',
    '$rootScope',
    'Pay',
    function (configs, $translate,
              $location, $state, $interval, $rootScope, Pay) {
        return {
            restrict: 'E',
            scope: {
                operators: '=',
            },
            template: require('../templates/mobileDropdown.html'),
            link: function (scope, element) {
                scope.Pay = Pay;
                scope.config = scope.operators;
                var html = angular.element(document.getElementsByTagName("html"))[0];

                function init () {
                    var ratio = window.devicePixelRatio || 1;
                    var mobileDropdown = angular.element(document.getElementsByClassName("mobileDropdown"))[0];
                    mobileDropdown.style.width = scope.config.screenParams.width + 'px';
                    mobileDropdown.style.height = scope.config.screenParams.height + 'px';
                    html.style.overflow = 'hidden';
                }

                scope.closePopup = function() {
                    html.style.overflow = 'auto';
                    scope.config.open = false;
                };

                scope.setPhone = function(operator, code) {
                    Pay.mobileNmbWidget(operator, code);
                    html.style.overflow = 'auto';
                    scope.config.open = false;
                };

                init();
            }
        }
    }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/mobileDropdown/directives/mobileDropdown.js
 ** module id = 187
 ** module chunks = 1
 **/